'use client'

import { useLayoutEffect } from 'react'

import { useShallow } from 'zustand/react/shallow'

import { selectGraftcodeOnboardingDashboardExperience } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.selector'
import { useGraftcodeOnboardingStore } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.store'

import { useGraftcodeOnboardingHydrate } from './useGraftcodeOnboardingHydrate'

export function useGraftcodeOnboardingDashboardLayout() {
  useGraftcodeOnboardingHydrate()
  const experience = useGraftcodeOnboardingStore(useShallow(selectGraftcodeOnboardingDashboardExperience))

  useLayoutEffect(() => {
    if (!experience.tutorialActive) {
      document.documentElement.classList.remove('graftcode-tutorial-active')
      return
    }
    document.documentElement.classList.add('graftcode-tutorial-active')
    window.scrollTo(0, 0)
    return () => {
      document.documentElement.classList.remove('graftcode-tutorial-active')
    }
  }, [experience.tutorialActive])

  return experience
}
